import keycode from 'keycode'
import { useCallback, useState } from 'react'

import useKeyBinding from '@hooks/useKeyBinding'

function useNavigationListItems(maxItems: number) {
  const [activeIndex, setActiveIndex] = useState(-1)
  const keyBindCallback = useCallback(
    (e: KeyboardEvent) => {
      if (keycode(e) === 'down') {
        setActiveIndex(prev => (prev <= maxItems ? prev + 1 : prev))
      } else if (keycode(e) === 'up') {
        setActiveIndex(prev => (prev > 0 ? prev - 1 : 0))
      }
    },
    [maxItems],
  )

  useKeyBinding(keyBindCallback)

  const resetIndex = useCallback(() => {
    setActiveIndex(0)
  }, [])

  const setIndex = useCallback((index: number) => {
    setActiveIndex(index)
  }, [])

  return {
    activeIndex,
    resetIndex,
    setIndex,
  }
}

export default useNavigationListItems
